export type ShortcutGroup = "Chats" | "General" | "Grid Mode" | "Terminal" | "Prompt"

export type CuratedShortcut = {
  id: string
  title: string
  group: ShortcutGroup
  defaultKeybind: string
}

export const SHORTCUT_GROUPS: ShortcutGroup[] = ["Chats", "General", "Grid Mode", "Terminal", "Prompt"]

export const DEFAULT_TOGGLE_TERMINAL_KEYBIND =
  typeof navigator === "object" && /^Win/.test(navigator.platform) ? "meta+'" : "ctrl+`"

export const CURATED_SHORTCUTS: CuratedShortcut[] = [
  { id: "session.new", title: "New chat", group: "Chats", defaultKeybind: "mod+shift+enter" },
  { id: "session.archive", title: "Archive chat", group: "Chats", defaultKeybind: "mod+shift+a" },
  { id: "session.previous", title: "Previous chat", group: "Chats", defaultKeybind: "mod+shift+arrowup" },
  { id: "session.next", title: "Next chat", group: "Chats", defaultKeybind: "mod+shift+arrowdown" },
  { id: "workspace.new", title: "New workspace", group: "General", defaultKeybind: "mod+shift+o" },
  { id: "search.open", title: "Search Kettle", group: "General", defaultKeybind: "mod+k" },
  { id: "settings.open", title: "Open settings", group: "General", defaultKeybind: "mod+comma" },
  { id: "model.choose", title: "Open provider menu", group: "General", defaultKeybind: "mod+shift+p" },
  { id: "model.variant.cycle", title: "Cycle thinking level", group: "General", defaultKeybind: "mod+shift+e" },
  { id: "sidebar.toggle", title: "Toggle left sidebar", group: "General", defaultKeybind: "mod+shift+l" },
  { id: "rightSidebar.toggle", title: "Toggle right sidebar", group: "General", defaultKeybind: "mod+shift+k" },
  { id: "grid.mode.toggle", title: "Toggle Grid Mode", group: "Grid Mode", defaultKeybind: "mod+shift+g" },
  { id: "grid.layout.toggle", title: "Toggle grid layout", group: "Grid Mode", defaultKeybind: "mod+shift+h" },
  { id: "grid.window.close", title: "Close window", group: "Grid Mode", defaultKeybind: "mod+shift+c" },
  { id: "terminal.toggle", title: "Toggle terminal", group: "Terminal", defaultKeybind: DEFAULT_TOGGLE_TERMINAL_KEYBIND },
  { id: "agent.cycle", title: "Cycle Build/Plan mode", group: "Prompt", defaultKeybind: "mod+shift+b" },
  { id: "prompt.interrupt", title: "Interrupt", group: "Prompt", defaultKeybind: "escape, ctrl+c" },
]

const defaults = new Map(CURATED_SHORTCUTS.map((shortcut) => [shortcut.id, shortcut.defaultKeybind]))

export function defaultShortcut(id: string) {
  return defaults.get(id)
}
